var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mdb-container',[(_vm.showSpinner)?_c('mdb-col',[_c('Spinner')],1):_vm._e(),_c('mdb-row',[_c('StationForm',{on:{"station-created":_vm.onStationCreated}})],1),_c('mdb-row',[_c('StationList',{attrs:{"stations":_vm.stations}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }